document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#ContactForm');
  if (!form) return;
  const params = new URLSearchParams(window.location.search);
  const product = (params.get('product') || '').trim().slice(0, 250);
  const enquiryMessages = {
    'bespoke commission': ['Bespoke commission', 'I would like to discuss a bespoke commission.'],
    'bespoke engagement ring': ['Bespoke engagement ring', 'I would like to discuss a bespoke engagement ring.'],
    'sapphire engagement ring': ['Sapphire engagement ring', 'I would like to discuss a sapphire engagement ring.']
  };
  const enquiry = enquiryMessages[params.get('enquiry')?.toLowerCase()];
  const message = document.querySelector('#ContactForm-body');
  const productField = document.querySelector('#ContactForm-product');
  const productWrapper = document.querySelector('.thf-product-reference');
  const enquiryType = document.querySelector('#ContactForm-enquiry-type');
  const productUrl = document.querySelector('#ContactForm-product-url');
  const piece = params.get('piece') || '';
  // Accept only Shopify handles; never forward an arbitrary URL from the query.
  if (product && productUrl && /^[a-z0-9][a-z0-9-]{0,254}$/.test(piece)) {
    productUrl.value = `${window.location.origin}/products/${piece}`;
    productUrl.disabled = false;
    const pieceLink = document.querySelector('#ContactForm-piece-link');
    if (pieceLink) {
      pieceLink.querySelector('a').href = productUrl.value;
      pieceLink.hidden = false;
    }
  }
  if (enquiryType) enquiryType.value = product ? 'Product enquiry' : enquiry ? enquiry[0] : 'General enquiry';
  if (product) {
    if (productField) productField.value = product;
    if (productWrapper) productWrapper.hidden = false;
  }
  // Preserve a visitor's message, including Shopify's validation-error response.
  if (!message || message.value.trim()) return;
  if (product) message.value = `I would like to enquire about ${product}.\n\n`;
  else if (enquiry) message.value = `${enquiry[1]}\n\n`;
});
